import { Component } from 'react';
import AuthApis from '../hepler/authApis.service';
import { toast } from 'react-toastify';
import { Dialog, DialogContent, Divider, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { postMessage } from '../utils/common.utils';
import {
	captureOtpPageLoad,
	captureOtpInputStart,
	captureOtpVerificationAttempt,
	captureOtpVerificationResult,
	captureOtpInputTriggered,
	captureOtpInputProgress,
	calculateOtpProgressMetrics,
	shouldTrackOtpProgress,
	captureConsentRenewalOtpPageLoad,
	captureConsentRenewalOtpInputStart,
	captureConsentRenewalOtpVerificationAttempt,
	captureConsentRenewalOtpVerificationResult,
	captureConsentRenewalOtpInputTriggered,
	captureConsentRenewalOtpInputProgress,
	captureMfaFlowStarted,
	captureMfaStepViewed,
	captureMfaFlowCompleted,
	captureMfaFlowFailed,
	captureMfaSnaStarted,
	captureMfaSnaCompleted,
	captureMfaSnaFallbackToOtp,
} from '../utils/analytics/posthog.utils';
import {
	Avatar,
	Box,
	Button,
	Icon,
	Link,
	Stack,
	TextField,
	Typography,
} from '@mui/material';
import LoginRight from './Login/LoginRight';
import SetTheme from './common/SetTheme';
import CircularProgress from '@mui/material/CircularProgress';
import DialogBox from './Dialog Box/Dialog Box';
import DenyConsent from './Accounts/DenyConsent';
import CancelConsent from './Accounts/CancelConsent';
import LoginRightContent from './Login/LoginRightContent';
import loginLeftStyles from './Login/LoginLeft.styles';
import Expired from './Expired';
import loginStyles from './Login/Login.styles';
import ConsentListContext from './Context/ConsentContext';
import finvuLogo from '../assets/finvuLogoNew.png';
import LockIcon from '@mui/icons-material/Lock';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import VpnKeyOutlinedIcon from '@mui/icons-material/VpnKeyOutlined';
import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';
import GppGoodOutlinedIcon from '@mui/icons-material/GppGoodOutlined';
import { getFiTypesHash } from '../hepler/functions';
import LoginFooter from './Sections/LoginFooter';
import StepperBar from './common/Stepper';
import StepperContext from './Context/StepperContext';
import { redirectAccountRestrictionsValidator } from '../utils/targetedAccounts.utils';
import LoginOtpGroupedField from './Login/LoginOtpGroupedField';
import Drawer from './Drawer/Drawer';
import { getOtpPageHeading, getOtpPageSubHeading, decodeBase64, parseAdditionalParams, handleRedirect } from '../utils/login.utils';
import { grantMfaEntry } from '../utils/authRouteGuard.utils';
import { PAGE_HEADING_ID } from '../utils/pageHeading.utils';
import { processCompleteEntityConfig, is2FAEnabled } from '../utils/entityConfig.utils';
import { withTranslation } from '../hoc/withTranslation';
import Footer from './Sections/Footer';
import TrustMarker from './common/TrustMarker';
import SnaLoader from './Mfa/SnaLoader';

class Login extends Component {
	static contextType = ConsentListContext;
	constructor(props) {
		super(props);
		const queryParams = new URLSearchParams(window.location.search);		
		this.ecreq = queryParams.get('ecreq');
		this.reqdate = queryParams.get('reqdate');
		this.fi = queryParams.get('fi')
			? queryParams.get('fi').split(' ').join('+')
			: null;
		this.requestorType = queryParams.get('requestorType')
			? queryParams.get('requestorType')
			: null;
		global.requestorType = queryParams.get('requestorType')
			? queryParams.get('requestorType')
			: null;
		try {
			this.fips = queryParams.get('fip')
				? window.atob(queryParams.get('fip'))
				: null;
		} catch (e) {
			this.fips = queryParams.get('fip') || null;
		}
		if (this.fips) {
			global.targetedFips = Array.isArray(this.fips)
				? this.fips
				: this.fips.split(',').map((f) => f.trim()).filter(Boolean);
		}
		this.channelId = queryParams.get('channelId') ?? null;
		this.language = queryParams.get('language') ?? null;
		this.additionalParams = queryParams.get('additionalParams') ?? null;
		global.isAddAccount = queryParams.get('isAddAccount') ? true : false;
		this.profile = queryParams.get('profile') ?? null;
		this.encryptedConsentId = queryParams.get('consentId') ?? null;
		this.reviewConsentParams = queryParams.get('reviewConsentParams') ?? null;
		this.otpPageHeading = "";
		this.otpPageSubHeading = "";
		this.encryptedDisplayName = queryParams.get('displayName') ?? null;
		global.renewConsentId = queryParams.get('renewConsentId') ?? null;
		this.isConsentRenewal = queryParams.get('isConsentRenewal')?.toLowerCase();
		this.state = {
			time: 60,
			OTP: '',
			isResend: true,
			isOpenSheet: false,
			isDisable: false,
			disableType: '',
			theme: undefined,
			mobileNo: '',
			newUser: null,
			consentRequestList: [],
			showDetails: false,
			showInfoDrawer: false,
			showInfoDialog: false,
			error: '',
			isExpired: false,
			consentList: [],
			showTermsModal: false,
		showPrivacyModal: false,
			isCheckValid: false,
			errors: {},
			pageLoadTime: null,
			verificationAttempts: 0,
			otpTriggerCount: 0,
			lastInputTime: null,
			correctionCount: 0,
			consentDetailList: [],
			reviewConsentFlow: false,
			consentId: null,
			name: null,
			loginStage:'',
			isSNAConfigured:false,
			showSNADrawer: false,
			showCancelDialog: false,
			showCancelDrawer: false,
			headerHeight: 70,
			snaLoader: false,       // shows SnaLoader bottom sheet during SNA auth
			snaOutcome: null,       // 'success' | 'fail' injected after SNA resolves
		};
		this.number = null;
		this.authApis = new AuthApis();
		this.hasTrackedInputStart = false;
		this._resumeAfterMfaStarted = false;
		this.calculateHeaderHeight = () => {
			const appBar = document.querySelector('header.MuiAppBar-root');
			if (!appBar) return;

			const height = Math.ceil(appBar.getBoundingClientRect().height);
			if (height !== this.state.headerHeight) {
				this.setState({ headerHeight: height });
			}

			appBar.querySelectorAll('img').forEach((img) => {
				if (!img.complete) {
					img.addEventListener('load', this.calculateHeaderHeight, { once: true });
				}
			});
		};
	}
	ensureLoginEntryFromPreLogin = () => {
		if (!is2FAEnabled(this.props.customDetails)) {
			return true;
		}
		if (this.props.location?.pathname === '/') {
			return true;
		}
		if (this._loginEntryGranted) {
			return true;
		}
		const { fromPreLogin, continueAfterMfa } = this.props.location?.state || {};
		if (!fromPreLogin && !continueAfterMfa) {
			this.props.history.replace({
				pathname: '/',
				search: window.location.search,
			});
			return false;
		}
		this._loginEntryGranted = true;
		return true;
	};

	componentDidMount() {
		if (!this.ensureLoginEntryFromPreLogin()) {
			return;
		}

		// Track page load time immediately
		const pageLoadTime = performance.now();
		this.setState({ pageLoadTime });

		this.calculateHeaderHeight();
		window.addEventListener('resize', this.calculateHeaderHeight);
		window.addEventListener('load', this.calculateHeaderHeight);

		// DEV: preview SNA loader stages from browser console
		// Usage: _testSnaLoader()         → checking→confirming→success→closes
		//        _testSnaLoader('fail')    → checking→confirming→fail→OTP fallback
		window._testSnaLoader = (outcome) => {
			this.setState({ snaLoader: true, snaOutcome: null }, () => {
				if (outcome === 'fail') {
					setTimeout(() => this.setState({ snaOutcome: 'fail' }), 1200);
				}
			});
			console.log('[DEV] SnaLoader preview started. outcome:', outcome || 'success');
		};

		const appBar = document.querySelector('header.MuiAppBar-root');
		if (appBar) {
			this.headerObserver = new MutationObserver(this.calculateHeaderHeight);
			this.headerObserver.observe(appBar, {
				childList: true,
				subtree: true,
				attributes: true,
			});
		}

		requestAnimationFrame(() => this.calculateHeaderHeight());
		window.addEventListener('finvu:openExitConfirm', this.openExitConfirm);

		if (this.props.sdkReady && this.props.location?.state?.continueAfterMfa) {
			this.resumeAfterMfaChoice();
			return;
		}

		if (
			this.props.sdkReady &&
			!this.props?.location?.state?.fromTerm &&
			!this.props.redirectToVersion
		) {
			this.getFiuInfo();
		}
	}
	componentWillUnmount() {
		window.removeEventListener('resize', this.calculateHeaderHeight);
		window.removeEventListener('load', this.calculateHeaderHeight);
		window.removeEventListener('finvu:openExitConfirm', this.openExitConfirm);
		this.headerObserver?.disconnect();
	}
	componentDidUpdate(prevProps) {
		if (
			prevProps.location?.state?.fromPreLogin !== this.props.location?.state?.fromPreLogin ||
			prevProps.location?.state?.continueAfterMfa !== this.props.location?.state?.continueAfterMfa
		) {
			if (!this.ensureLoginEntryFromPreLogin()) {
				return;
			}
		}

		if (
			this.props.location?.state?.continueAfterMfa &&
			!prevProps.location?.state?.continueAfterMfa
		) {
			this.resumeAfterMfaChoice();
			return;
		}

		if (
			!prevProps.sdkReady &&
			this.props.sdkReady &&
			this.props.location?.state?.continueAfterMfa
		) {
			this.resumeAfterMfaChoice();
			return;
		}

		if (prevProps.location.pathname !== this.props.location.pathname) {
			if (this.props.history.action === 'POP') {
				window.confirm(
					'Are you sure to go back ? Consent will not be actioned.'
				);
			}
		}
		// Only call getFiuInfo when sdkReady transitions from false to true
		if (!prevProps.sdkReady && this.props.sdkReady) {
			this.calculateHeaderHeight();
			requestAnimationFrame(() => this.calculateHeaderHeight());
			if (
				!this.props?.location?.state?.fromTerm &&
				!this.props.redirectToVersion &&
				!this.props.location?.state?.continueAfterMfa
			) {
				this.getFiuInfo();
			}
		}
	}
	initiate = () => {
		// if (this.state.time !== 0) {
		this.setState((prevState, prevProps) => ({
			time: prevState.time - 1,
		}));
		if (this.state.time === 0) {
			clearInterval(this.id);
			this.setState({ time: 60, isResend: true });
		}
		// }
	};
	getFiuInfo = () => {
		this.props.updateInitialLoader(true);
		let options = {};
		if(global.renewConsentId){
			options.encryptedConsentId = global.renewConsentId;
		}
		if(this.encryptedConsentId){
			options.encryptedConsentId = this.encryptedConsentId;
		}
		if(this.encryptedDisplayName){
			options.encryptedDisplayName = this.encryptedDisplayName;
		}
		this.authApis.getFiuInfo(this.ecreq, this.reqdate, this.fi, this.requestorType, options)
			.then((res) => {
				if (res?.payload?.status === 'SUCCESS') {
					this.props.toggleTimer();
					let entityId = res.payload?.entityInfo?.entityId;
				let no = res.payload?.userIdOrMobileNo;
				this.setState({ mobileNo: no, newUser: res.payload?.newUser });
				global.newUser = res.payload?.newUser;
				if (res.payload?.newUser === 'N' || res.payload?.newUser === false) {
					global.isReturningUser = true;
					global.journeyType = 'login';
				}
					this.setState({ reviewConsentFlow: res.payload?.consentIdReferenceValid });
					this.setState({ consentId: res.payload?.consentIdReference });
					this.setState({ consentDetailList: res.payload?.consentDetails });
					this.setState({ name: res.payload?.displayName });
				global.institutionType = res.payload?.institutionType;
				global.redirectUrl = res.payload?.redirectUrl;
				global.encryptedres = res.payload?.encryptedres;
				global.resDate = res.payload?.resDate;
				global.encryptedFiId = res.payload?.encryptedFiId;
				global.redirectAccountRestrictions = redirectAccountRestrictionsValidator(res.payload?.accounts);
				// Set targeted discovery mode flag if restrictions exist
				if (global.redirectAccountRestrictions) {
					global.isTargetedDiscoveryMode = true;
				}
				if (res.payload?.fips) {
					this.fips = res.payload.fips;
				}
				if (this.fips) {
					global.targetedFips = Array.isArray(this.fips)
						? this.fips
						: this.fips.split(',').map((f) => f.trim()).filter(Boolean);
				}
				if (
					res.payload?.displayOnlyTargetedFips === true ||
					res.payload?.displayOnlyTargetedFips === 'true'
				) {
					global.displayOnlyTargetedFips = true;
				}
				if (
					res.payload?.terminateOnNoAccountFound === true ||
					res.payload?.terminateOnNoAccountFound === 'true'
				) {
					global.terminateOnNoAccountFound = true;
				}
				global.entityName = res.payload?.entityInfo?.entityName;
					global.mobileNumber = res.payload?.mobileNumber;
					const rawSrc = res.payload?.srcRef || res.payload?.src_ref || res.payload?.consentHandle || res.payload?.consentIdReference;
					const singleSrc = Array.isArray(rawSrc) ? rawSrc[0] : (typeof rawSrc === 'string' && rawSrc.includes(',') ? rawSrc.split(',')[0].trim() : rawSrc);
					global.srcRef = singleSrc;
					global.consentHandle = singleSrc;

					if (res.payload?.consentIdReference && global.renewConsentId && this.isConsentRenewal === 'true') {
						global.renewConsentId = res.payload.consentIdReference;
					}

					if (entityId) {
						// this.sendOtp()
						global.entityId = entityId;
						this.getConfigInfo(entityId);
					} else {
						this.props.updateInitialLoader(false);
						// this.props.history.push(`/error`)
						if (res?.code === undefined || res?.code === null || res?.code === "") {
							toast.error(res?.message);
						} else {
							toast.error(this.props.t(`errors.code.${res.code}`));
						}
						if (res.status === 'FAILURE') {
							postMessage('session', 'FAILURE');
						} else if (res.status === 'ERROR' ) {
							postMessage('session', 'ERROR');
						}
					}
				}
				 else {
					global.redirectUrl = res?.message?.redirectUrl;
					global.encryptedres = res?.message?.encryptedres;
					global.resDate = res?.message?.resDate;
					global.encryptedFiId = res?.message?.encryptedFiId;
					if (res?.code === undefined || res?.code === null || res?.code === "") {
						toast.error(res.message);
					} else {
						toast.error(this.props.t(`errors.code.${res.code}`));
					}
					this.setState({ isExpired: true });
					this.props.updateInitialLoader(false);
				}
			});
	};
	getConfigInfo = (entityId) => {
		let redirectToVersion = true;
		this.authApis.fiuSdkConfig(entityId).then((res) => {
			if (res?.status === 'SUCCESS') {
				// Gateway logic
				const environment = process.env.REACT_APP_ENVIRONMENT;
				const version = res.entityConfig.sdkOptions.version;
				const defaultVersion = process.env.REACT_APP_DEFAULT_VERSION;
				const otherRedirectionUrl =
					process.env.REACT_APP_OTHER_VERSION_REDIRECTION_URL;
				const specialUrl = 'https://sweecar.finvu.in';
				//Case-insensitive version check
				if (version) {
					// sweecar.finvu.in specific code to stop infinite redirection
					if (
						version.toLowerCase() === defaultVersion.toLowerCase() ||
						(version.toLowerCase() === 'v3' &&
							window.location.hostname === 'sweecar.finvu.in')
					) {
						redirectToVersion = false;
					}
				} else {
					if (environment === 'UAT') {
						redirectToVersion = false;
					}
				}
				if (redirectToVersion) {
					const queryParams = new URLSearchParams(window.location.search);
					let redirectionUrl = '';
					// handle null case for version
					if (version && version.toLowerCase() === 'v3') {
						redirectionUrl = specialUrl;
					} else redirectionUrl = otherRedirectionUrl;
					window.location.replace(
						redirectionUrl + '?' + queryParams.toString()
					);
				}

				// Process entity configuration using utility
				const { themeConfig, updatedFips } = processCompleteEntityConfig(
					res,
					this.profile,
					this.fips
				);
				// Update theme config and FIPs
				if (themeConfig) {
					this.props.updateEntityID(themeConfig);
				}
				this.fips = updatedFips;
				// Load entity-specific translations if available
				if (global.alternativeText && this.props.changeLanguage) {
					const currentLanguage = this.props.currentLanguage;
					this.props.changeLanguage(currentLanguage);
				}
			// Validate consentId and isConsentRenewal parameters after successful login
			if (
				(global.renewConsentId && !this.isConsentRenewal) || 
				(!global.renewConsentId && this.isConsentRenewal) ||
				(global.renewConsentId && this.isConsentRenewal && this.isConsentRenewal !== 'true')
			) {
				this.props.updateInitialLoader(false);
				this.props.history.push({
					pathname: `/consent-renew-status`,
					state: {
						status: 'Invalid parameters',
						statusCode: 20,
					},
				});
				return;
			}
				
				// Track page load after we know analytics is enabled
				if (global?.sdkOptions?.analyticsEnabled) {
					const loadTime = performance.now() - this.state.pageLoadTime;
					if (global.renewConsentId && this.isConsentRenewal === 'true') {
						captureConsentRenewalOtpPageLoad({ loadTime });
					} else {
						captureOtpPageLoad({ loadTime });
					}
				}
		} else {
			this.props.updateInitialLoader(false);
		}
		
		// Check for voice journey first - it takes precedence over SNA and OTP
		if (this.additionalParams) {
			const decodedParams = decodeBase64(this.additionalParams);
			if (decodedParams && decodedParams !== 'null' && decodedParams !== 'undefined') {
				const parsedParams = parseAdditionalParams(decodedParams);				
				if (parsedParams.channelId === 'AI_VOICE' || parsedParams.channelId === 'ai_voice') {
					this.state.loginStage = 'VERIFY_OTP'
					const normalizedChannelId = 'AI_VOICE';					
					this.consentJourneyInitiate(normalizedChannelId, parsedParams.language);
					return;
				}
			}
		}

		// Check SNA configuration (only if not voice journey)
		this.state.isSNAConfigured = res?.entityConfig?.sdkOptions?.isSNAConfigured;
		if(res?.entityConfig?.sdkOptions?.isSNAConfigured == "true"){
			this.setState({ isDisable: false });
			this.props.updateInitialLoader(false);
			if (is2FAEnabled(res?.entityConfig?.sdkOptions)) {
				this.props.updateLoginStageLoader({ isLoading: true, loadingText: '' });
				this.sendOtp(false);
			} else {
				this.state.loginStage = 'PRE_AUTH_CHECK';
			}
		}
		else{
			this.state.loginStage = 'VERIFY_OTP'
			// Handle ai_voice channel journey
			if (this.additionalParams) {
				const decodedParams = decodeBase64(this.additionalParams);
				if (decodedParams && decodedParams !== 'null' && decodedParams !== 'undefined') {
					const parsedParams = parseAdditionalParams(decodedParams);				
					if (parsedParams.channelId === 'AI_VOICE' || parsedParams.channelId === 'ai_voice') {
						this.consentJourneyInitiate(parsedParams.channelId, parsedParams.language);
					}else{
						this.sendOtp(redirectToVersion);
					}
				}else{
					this.sendOtp(redirectToVersion);
				}
			}else{
				this.sendOtp(redirectToVersion);
			}	
		}
		
	});
};

	consentJourneyInitiate = (channelId, language) => {
		this.authApis.consentJourneyInitiate(channelId, language).then((res) => {
			if(res){
				console.log(res, 'res');
				if(res.aiVoiceStatus === 'FAILED' || res.status=== 'FAILURE'){
					console.log('Call Failed');
					this.props.updateInitialLoader(false);
					const responseCode = res?.code || res?.message?.code || res?.payload?.code;
					const initiateErrorCodeMap = {
						F400: { statusCode: 433, errorCode: 'BAD_REQUEST' },
						F401: { statusCode: 432, errorCode: 'UNAUTHORIZED' },
						F403: { statusCode: 434, errorCode: 'USER_MISMATCHED' },
						F408: { statusCode: 435, errorCode: 'FIU_MISMATCHED' },
						F410: { statusCode: 436, errorCode: 'ACCOUNT_NOT_LINKED' },
						F411: { statusCode: 437, errorCode: 'FI_TYPE_MISMATCHED' },
						F412: { statusCode: 439, errorCode: 'ALREADY_PROCESSED' },
						F413: { statusCode: 438, errorCode: 'CANNOT_SERVE_REQUEST' },
						F500: { statusCode: 440, errorCode: 'INTERNAL_SERVER_ERROR' },
					};
					const mappedInitiateError = initiateErrorCodeMap[responseCode];
					const responseMessage =
						typeof res?.message === 'string'
							? res.message
							: res?.message?.message || res?.payload?.message || '';
					
					if (mappedInitiateError) {
						this.props.history.push({
							pathname: `/consent-status`,
							state: {
								status: 'Call Failed',
								statusCode: mappedInitiateError.statusCode,
								errorCode: mappedInitiateError.errorCode,
								errorMessage: responseMessage,
								errorDetails:
									res?.details ||
									res?.errorDetails ||
									res?.invalidFields ||
									[],
								type: 'voice journey',
							},
						});
					}
					// Backward compatibility for older error shape without code.
					else if(res.message === 'Request already processed' || res.message?.message === 'Request already processed'){
						this.props.history.push({
							pathname: `/consent-status`,
							state: {
								status: 'Request Already Processed',
								statusCode: 439,
								errorCode: 'ALREADY_PROCESSED',
								type: 'voice journey',
							},
						})
					}
					else{
						this.props.history.push({
							pathname: `/consent-status`,
							state: {
								status: 'Call Failed',
								statusCode: 411,
								type: 'voice journey',
							},
						})
					}
				}
				else{
					this.props.updateInitialLoader(false);
					this.voiceJourneyStatus(res.aiVoiceReferenceId, res.userId);
					this.props.history.push({
						pathname: `/voice-journey`,
						state: {
							aiVoiceReferenceId: res.aiVoiceReferenceId,
							userId: res.userId,
						},
					});
				}
			}else{
			    handleRedirect();
			}
		});
	}

	//voice journey status
	voiceJourneyStatus = (aiVoiceReferenceId, userId) => {		
		const POLLING_INTERVAL = 10 * 1000; // 10 seconds
		const MAX_DURATION = 30 * 60 * 1000; // 30 minutes
		
		// Start time for tracking duration
		const startTime = Date.now();
		let hasNavigated = false; // Track if we've navigated to consent-status
		let hasShownRunning = false; // Track if RUNNING status has been shown
		let journeyFinalized = false; // true once API returns a terminal state or client max-duration fires
		let intervalId;
		let maxDurationTimeoutId;

		const markJourneyFinalAndStopTimers = () => {
			journeyFinalized = true;
			if (intervalId != null) {
				clearInterval(intervalId);
			}
			if (maxDurationTimeoutId != null) {
				clearTimeout(maxDurationTimeoutId);
				maxDurationTimeoutId = null;
			}
		};

		// Function to call the status endpoint
		const callStatusCheck = async () => {
			try {
				const res = await this.authApis.consentJourneyStatus(aiVoiceReferenceId, userId);

				const statusMap = {
					'APPROVED': { statusCode: 200, status: 'Consent Approved', isFinal: true },
					'DENY': { statusCode: 201, status: 'Consent Denied', isFinal: true },
				};

				const callEndedMap = {
					'USER_HANGUP': { statusCode: 412, status: 'Call Ended', isFinal: true },
					'AGENT_HANGUP': { statusCode: 413, status: 'Call Ended', isFinal: true },
					'USER_UNAVAILABLE': { statusCode: 414, status: 'Call Ended', isFinal: true },
					'MAX_DURATION': { statusCode: 415, status: 'Call Ended', isFinal: true },
					'VOICEMAIL_REACHED': { statusCode: 416, status: 'Call Ended', isFinal: true },
					'SILENCE_TIMEOUT': { statusCode: 417, status: 'Call Ended', isFinal: true },
					'ERROR_OCCURRED': { statusCode: 418, status: 'Call Ended', isFinal: true },
					'USER_REJECTED': { statusCode: 419, status: 'Call Ended', isFinal: true },
					'CALL_NOT_PICKED':{ statusCode: 420, status: 'Call Ended', isFinal: true },
					'CALL_NOT_CONNECTED' : { statusCode: 421, status: 'Call Ended', isFinal: true },
					'CALL_DROPPED' : { statusCode: 422, status: 'Call Ended', isFinal: true },
					'OTHER':{ statusCode: 423, status: 'Call Ended', isFinal: true },
					// Keep technical voice errors in a dedicated range to avoid collisions with call progress states.
					'UNAUTHORIZED':{ statusCode: 432, status: 'Call Ended', isFinal: true, errorCode: 'UNAUTHORIZED' },
					'BAD_REQUEST': {statusCode: 433, status: 'Call Ended', isFinal: true, errorCode: 'BAD_REQUEST' },
					'USER_MISMATCHED': {statusCode: 434, status: 'Call Ended', isFinal: true, errorCode: 'USER_MISMATCHED' },
					'FIU_MISMATCHED': {statusCode: 435, status: 'Call Ended', isFinal: true, errorCode: 'FIU_MISMATCHED' },
					'ACCOUNT_NOT_LINKED': {statusCode: 436, status: 'Call Ended', isFinal: true, errorCode: 'ACCOUNT_NOT_LINKED' },
					'FI_TYPE_MISMATCHED': {statusCode: 437, status: 'Call Ended', isFinal: true, errorCode: 'FI_TYPE_MISMATCHED' },
					'ALREADY_PROCESSED': {statusCode: 439, status: 'Call Ended', isFinal: true, errorCode: 'ALREADY_PROCESSED' },
					'CANNOT_SERVE_REQUEST': {statusCode: 438, status: 'Call Ended', isFinal: true, errorCode: 'CANNOT_SERVE_REQUEST' },
					'INTERNAL_SERVER_ERROR': {statusCode: 440, status: 'Call Ended', isFinal: true, errorCode: 'INTERNAL_SERVER_ERROR' },

				};

				const callStatusMap = {
					'QUEUED': { statusCode: 424, status: 'Initiating Call', isFinal: false },
					'RINGING': { statusCode: 425, status: 'Calling Customer', isFinal: false },
					'RUNNING': { statusCode: 426, status: 'Call Picked', isFinal: false },
				};

				let statusData = null;
				const responseCode = res?.code || res?.message?.code || res?.payload?.code;
				console.log('responseCode', responseCode);
				const responseCodeToDisconnectionReasonMap = {
					F400: 'BAD_REQUEST',
					F401: 'UNAUTHORIZED',
					F403: 'USER_MISMATCHED',
					F408: 'FIU_MISMATCHED',
					F410: 'ACCOUNT_NOT_LINKED',
					F411: 'FI_TYPE_MISMATCHED',
					F412: 'ALREADY_PROCESSED',
					F413: 'CANNOT_SERVE_REQUEST',
					F500: 'INTERNAL_SERVER_ERROR',
				};
				const mappedDisconnectionReason = responseCodeToDisconnectionReasonMap[responseCode];

				if (mappedDisconnectionReason && callEndedMap[mappedDisconnectionReason]) {
					statusData = callEndedMap[mappedDisconnectionReason];
				} else if (res.consentStatus && statusMap[res.consentStatus]) {
					statusData = statusMap[res.consentStatus];
				} 
				else if (res.callStatus === 'ENDED' && res.disconnectionReason && callEndedMap[res.disconnectionReason]) {
					statusData = callEndedMap[res.disconnectionReason];
				}
				else if (res.callStatus && callStatusMap[res.callStatus]) {
					// Skip RUNNING status if we've already shown it and transitioned to "in progress"
					if (res.callStatus === 'RUNNING' && hasShownRunning) {
						// Don't update statusData - keep showing 427
						console.log("Voice journey in progress, skipping RUNNING status update...");
					} else {
						statusData = callStatusMap[res.callStatus];
						
						// When RUNNING status is detected first time, show it briefly then transition to "in progress"
						if (res.callStatus === 'RUNNING' && !hasShownRunning) {
							hasShownRunning = true;
							// After 1.5 seconds, show "Voice journey in progress" message
							setTimeout(() => {
								this.props.history.replace({
									pathname: `/consent-status`,
									state: {
										status: 'Voice Journey In Progress',
										statusCode: 427,
										type: 'voice journey',
									},
								});
							}, 2000);
						}
					}
				}

				if (statusData) {
					const stateData = {
						pathname: `/consent-status`,
						state: {
							status: statusData.status,
							statusCode: statusData.statusCode,
							errorCode: statusData.errorCode,
							errorMessage:
								res?.message ||
								res?.errorMessage ||
								res?.payload?.message ||
								'',
							errorDetails:
								res?.details ||
								res?.errorDetails ||
								res?.invalidFields ||
								[],
							type: 'voice journey',
						},
					};

					if (!hasNavigated) {
						// First time - navigate to consent-status
						this.props.history.push(stateData);
						hasNavigated = true;
					} else {
						// Subsequent updates - replace current location state
						this.props.history.replace(stateData);
					}

					// Only stop polling for final statuses; cancel max-duration fallback if journey ended
					if (statusData.isFinal) {
						markJourneyFinalAndStopTimers();
					}
				} else {
					console.log("Voice journey still in progress, continuing to poll...");
				}

				return res;
			} catch (error) {
				console.error("Error calling consentJourneyStatus endpoint:", error);
			}
		};
		
		// Set up polling interval
		intervalId = setInterval(async () => {
			if (journeyFinalized) {
				clearInterval(intervalId);
				return;
			}
			const currentTime = Date.now();
			const elapsedTime = currentTime - startTime;
			
			// Check if 30 minutes have passed
			if (elapsedTime >= MAX_DURATION) {
				markJourneyFinalAndStopTimers();
				this.props.history.push({
					pathname: `/consent-status`,
					state: {
						status: 'Call Ended',
						statusCode: 415,
						type: 'voice journey',
					},
				});
				return;
			}
			
			// Call the endpoint
			await callStatusCheck();
		}, POLLING_INTERVAL);
			
		// Set up timeout as a safety measure (only if journey never reached a final API state)
		maxDurationTimeoutId = setTimeout(() => {
			if (journeyFinalized) {
				return;
			}
			markJourneyFinalAndStopTimers();
			this.props.history.push({
				pathname: `/consent-status`,
				state: {
					status: 'Call Ended',
					statusCode: 415,
					type: 'voice journey',
				},
			});
		}, MAX_DURATION);
		callStatusCheck();
	}

	// Send OTP
	sendOtp = (redirectToVersion = true, nextStep) => {
		if (redirectToVersion) return;
		// Track OTP input trigger before incrementing counter
		const currentTime = performance.now();
		const otpTriggerMetrics = {
			triggerType: this.state.otpTriggerCount === 0 ? 'auto' : 'resend',
			triggerCount: this.state.otpTriggerCount + 1,
			timeSinceLastTrigger: this.state.time === 60 ? 0 : 60 - this.state.time,
			timeSincePageLoad: currentTime - this.state.pageLoadTime,
		};
		
		if (global.renewConsentId && this.isConsentRenewal === 'true') {
			captureConsentRenewalOtpInputTriggered(otpTriggerMetrics);
		} else {
			captureOtpInputTriggered(otpTriggerMetrics);
		}

		// Increment trigger counter after tracking
		this.setState((prevState) => ({
			otpTriggerCount: prevState.otpTriggerCount + 1,
		}));

		this.getOtp();
		this.setState({ isDisable: true, disableType: 'Resend' });
		console.log('[Login.js] Initiating login request (sendOtp)...');
		const enable2FA = is2FAEnabled();
		if (enable2FA) {
			captureMfaFlowStarted({
				journey: global.newUser === 'N' || global.newUser === false ? 'login' : 'signup',
			});
		}

		const handleMfaStep = async (step) => {
			console.log('[Login.js] Initial MFA step received:', step);
			window._currentMfaStep = step;
			captureMfaStepViewed({
				stepAction: step.action,
				factor: step.factor,
				availableFactors: step.availableFactors,
			});

			if (step.action === 'silent' && step.factor === 'sna') {
				console.log('[Login.js] SNA silent step active. Showing SnaLoader bottom sheet...');
				captureMfaSnaStarted();
				// Show the 3-stage animated bottom sheet
				this.setState({ snaLoader: true, snaOutcome: null });

				let nextStep;
				try {
					nextStep = await step.completion;
					console.log('[Login.js] SNA completion returned:', nextStep);
					captureMfaSnaCompleted();
					// Inject success outcome so SnaLoader plays the checkmark stage
					this.setState({ snaOutcome: 'success' });
				} catch (err) {
					console.warn('[Login.js] SNA silent auth failed:', err);
					captureMfaSnaFallbackToOtp({ error: err?.message });
					// Inject fail outcome — SnaLoader shows warning then calls onFail
					this.setState({ snaOutcome: 'fail' });
					return; // SnaLoader.onFail will call otpFlowHandler via _snaFallback
				}

				// Routing after SNA success (SnaLoader onDone closes the sheet)
				window._currentMfaStep = nextStep;
				if (nextStep.action === 'complete' && nextStep.result?.status === 'authenticated') {
					if (nextStep.result.session?.userId) {
						global.userId = nextStep.result.session.userId;
					}
					this.navigateToMfaChoice(nextStep);
				} else if (nextStep.action === 'selectFactor') {
					this.navigateToMfaChoice(nextStep);
				} else if (nextStep.action === 'input' && nextStep.factor === 'otp') {
					this.otpFlowHandler({ status: 'SEND' });
				} else {
					this.otpFlowHandler({ status: 'SEND' });
				}
			} else if (step.action === 'input' && step.factor === 'otp') {
				this.otpFlowHandler({ status: 'SEND' });
			} else if (step.action === 'input' && step.factor === 'pin') {
				this.navigateToMfaChoice(step);
			} else if (step.action === 'selectFactor') {
				this.navigateToMfaChoice(step);
			} else if (step.action === 'complete' && step.result?.status === 'authenticated') {
				if (step.result.session?.userId) {
					global.userId = step.result.session.userId;
				}
				this.navigateToMfaChoice(step);
			} else if (step.action === 'complete' && step.result?.status === 'failed') {
				toast.error(step.result.error?.message || 'Authentication failed');
				this.setState({ isDisable: false });
			}
		};

		if (enable2FA && window.mfaClient && typeof window.mfaClient.login === 'function') {
			this.authApis
				.mfaLogin()
				.then(handleMfaStep)
				.catch((err) => {
					console.error('[Login.js] mfaLogin error, falling back to userLogin:', err);
					this.authApis.userLogin().then(this.otpFlowHandler);
				});
		} else {
			this.authApis.userLogin().then(async (res) => {
				console.log('[Login.js] User Login Response From SDK:', res);
				if (res?.authType === "SNA") {
					console.log('[Login.js] SNA auth initiated');
					this.props.updateLoginStageLoader({isLoading:true, loadingText:"Securely Authenticating your number..."})
					if (res?.snaPromise) {
						let snaResponse = await res.snaPromise;
						console.log('[Login.js] SNA Promise resolved:', snaResponse);
						if (snaResponse?.status === "SUCCESS") {
							this.setState({ isDisable: false });
							const token = snaResponse?.token;
							this.verifyOtp(null, nextStep, token);
						} else {
							toast.error('Failed to verify via SIM provider. Please try manually')
							let fallbackResult = snaResponse.fallbackResult;
							this.otpFlowHandler(fallbackResult);
						}
					}else{
						this.otpFlowHandler(res);
					}
				} else {
					this.otpFlowHandler(res);
				}
			});
		}		
	};
	otpFlowHandler = (res) => {
		this.state.loginStage = 'VERIFY_OTP';
		this.setState({ isDisable: false });
		this.props.updateInitialLoader(false);
		this.props.updateLoginStageLoader({ isLoading: false });
		if (res.status === 'SEND') {
			if ('OTPCredential' in window) {
				window.addEventListener('DOMContentLoaded', (e) => {
					const ac = new AbortController();
					navigator.credentials
						.get({
							otp: { transport: ['sms'] },
							signal: ac.signal,
						})
						.then((otp) => {
							this.setState({ OTP: otp });
						})
						.catch((err) => {
							console.log(err);
						});
				});
			} else {
				console.log('WebOTP not supported!.');
			}
			} else if (res?.message?.code === 'C002') {
				this.props.history.push({
					pathname: `/consent-status`,
					state: {
						status: 'Consent Actioned',
						statusCode: 410,
					},
				});
		} else {
				if (res?.code === undefined || res?.code === null || res?.code === "") {
				toast.error(res?.message);
			// this.props.history.push(`/error`);
				} else {
					toast.error(this.props.t(`errors.code.${res.code}`));
				}
			if (res.status === 'FAILURE') {
				postMessage('session', 'FAILURE');
			} else if (res.status === 'ERROR') {
				postMessage('session', 'ERROR');
			}
		}
	};

	resumeAfterMfaChoice = () => {
		if (this._resumeAfterMfaStarted) {
			return;
		}
		this._resumeAfterMfaStarted = true;
		this.props.history.replace({
			pathname: '/login',
			search: window.location.search,
			state: {},
		});
		this.allFips();
	};

	navigateToMfaChoice = (nextStep) => {
		if (!is2FAEnabled()) {
			console.log('[Login.js] 2FA is not enabled. Skipping /mfa-choice and proceeding to allFips.');
			if (typeof nextStep === 'function') {
				nextStep(1);
			}
			this.allFips();
			return;
		}
		grantMfaEntry();
		if (typeof nextStep === 'function') {
			nextStep(1);
		}
		const isReturning = Boolean(
			global.isReturningUser ||
			global.newUser === 'N' ||
			global.newUser === false ||
			global.journeyType === 'login'
		);
		captureMfaStepViewed({
			stepAction: nextStep?.action || 'selectFactor',
			factor: nextStep?.factor,
			availableFactors: nextStep?.availableFactors,
		});
		this.props.history.push({
			pathname: '/mfa-choice',
			search: window.location.search,
			state: {
				authVerified: true,
				isReturningUser: isReturning,
				isPinRegistered: Boolean(global.isPinRegistered),
				journey: isReturning ? 'login' : 'signup',
			},
		});
	};

	verifyOtp = (e, nextStep, authToken) => {
		nextStep = nextStep ?? (() => {});
		e?.preventDefault();
		this.setState({ isDisable: true, disableType: 'Verify' });

		// Track verification attempt before incrementing counter
		const currentTime = performance.now();
		const totalTime = currentTime - this.state.pageLoadTime;
		const inputTime = this.hasTrackedInputStart
			? currentTime - this.state.lastInputTime
			: totalTime;

		const verificationAttemptMetrics = {
			attemptNumber: this.state.verificationAttempts + 1,
			totalTime,
			inputTime,
			isComplete: authToken!== null ?? this.state.OTP.length === 6,
		};
		
		if (global.renewConsentId && this.isConsentRenewal === 'true') {
			captureConsentRenewalOtpVerificationAttempt(verificationAttemptMetrics);
		} else {
			captureOtpVerificationAttempt(verificationAttemptMetrics);
		}

		// Increment attempt counter after tracking
		this.setState((prevState) => ({
			verificationAttempts: prevState.verificationAttempts + 1,
		}));
		let verifyToken = (authToken && authToken !== null && authToken !== "") ? authToken : this.state.OTP;
		console.log('[Login.js] Submitting verification with token:', verifyToken);

		const enable2FA = is2FAEnabled();
		if (enable2FA && window._currentMfaStep && window._currentMfaStep.action === 'input' && typeof window._currentMfaStep.submit === 'function') {
			console.log('[Login.js] Calling active step.submit()...');
			window._currentMfaStep.submit(verifyToken).then((nextStep) => {
				console.log('[Login.js] Step returned after submit:', nextStep);
				window._currentMfaStep = nextStep;
				captureMfaStepViewed({
					stepAction: nextStep.action,
					factor: nextStep.factor,
					availableFactors: nextStep.availableFactors,
				});

				if (authToken && authToken !== null && authToken !== "") {
					this.props.updateLoginStageLoader({ isLoading: false, isSuccess: true, successText: "Verification Successful" });
				}

				if (nextStep.action === 'selectFactor' || (nextStep.action === 'input' && nextStep.factor === 'pin')) {
					this.navigateToMfaChoice(nextStep);
				} else if (nextStep.action === 'complete' && nextStep.result?.status === 'authenticated') {
					captureMfaFlowCompleted({
						status: 'authenticated',
						journey: global.newUser === 'N' || global.newUser === false ? 'login' : 'signup',
					});
					if (nextStep.result.session?.userId) {
						global.userId = nextStep.result.session.userId;
					}
					if (this.state.reviewConsentFlow) {
						this.handleConsentApproval();
					} else {
						this.navigateToMfaChoice(nextStep);
					}
				} else if (nextStep.action === 'input' && nextStep.validationError) {
					toast.error(nextStep.validationError.message);
					this.setState({ isDisable: false, errors: { otp: true, message: nextStep.validationError.message } });
				} else if (nextStep.action === 'complete' && nextStep.result?.status === 'failed') {
					captureMfaFlowFailed({
						errorCode: nextStep.result.error?.code,
						errorMessage: nextStep.result.error?.message,
					});
					toast.error(nextStep.result.error?.message || 'Verification failed');
					this.setState({ isDisable: false });
				}
			}).catch((err) => {
				console.error('[Login.js] step.submit error:', err);
				captureMfaFlowFailed({
					errorMessage: err?.message,
				});
				this.setState({ isDisable: false });
			});
			return;
		}

		this.authApis.verifyOtp(verifyToken).then((res) => {
			if(authToken && authToken !== null && authToken !== ""){
				this.props.updateLoginStageLoader({ isLoading: false, isSuccess: true, successText: "Verification Successful" });
			}
			// Track verification result
			const resultTime = performance.now();
			const verificationResultMetrics = {
				success: res?.status === 'SUCCESS',
				status: res?.status,
				message: res?.message,
				totalAttempts: this.state.verificationAttempts,
				totalTime: resultTime - this.state.pageLoadTime,
			};
			
			if (global.renewConsentId && this.isConsentRenewal === 'true') {
				captureConsentRenewalOtpVerificationResult(verificationResultMetrics);
			} else {
				captureOtpVerificationResult(verificationResultMetrics);
			}

			if (res?.status && res?.status === 'SUCCESS') {
				if(res.userInfo && res.userInfo.userId){ global.userId = res.userInfo.userId; }
				// Handle review consent flow - approve consent automatically
				if (this.state.reviewConsentFlow) {
					this.handleConsentApproval();
				} else {
					if (enable2FA) {
						this.navigateToMfaChoice(nextStep);
					} else {
						// Regular flow - continue to accounts selection 
						if (typeof nextStep === 'function') {
							nextStep(1);
						}
						this.allFips();
					}
				}
			} else {
				if (!global?.sdkOptions?.hideAuthToaster) {
					if (res?.code === undefined || res?.code === null || res?.code === "") {
						toast.error(res?.message);
					} else {
						toast.error(this.props.t(`errors.code.${res.code}`));
					}
				} else {
					this.setState({
						errors: { otp: true, message: 'OTP Validation Failed' },
					});
				}
				this.setState({ isDisable: false });
				if (res.status === 'FAILURE') {
					postMessage('session', 'FAILURE');
				} else if (res.status === 'ERROR') {
					postMessage('session', 'ERROR');
				}
			}
		});
	};

	// New method to handle consent approval in review consent flow
	handleConsentApproval = async () => {
		try {
			 // For setting session in backend 
			const cD = await this.authApis.consentRequestDetailsSingle();
			const res = await this.authApis.consentRequestApproveWithConsentId(
				this.state.consentId, 
				'ACCEPT', 
				// only first consent handle id is used
				this.state.consentDetailList[0].consentHandleId, 
				global.entityId
			);

			if (res?.status === 'SUCCESS') {
				toast.success('Consent approved');
				// Navigate to consent status page
				this.props.history.push({
					pathname: `/consent-status`,
					state: {
						status: 'Consent approved',
						statusCode: 200,
					},
				});
			} else {
				toast.error(res?.message || 'Failed to approve consent');
				this.setState({ isDisable: false });
				if (res?.status === 'FAILURE') {
					postMessage('session', 'FAILURE');
				} else if (res?.status === 'ERROR') {
					postMessage('session', 'ERROR');
				}
				// Navigate to error status page
				setTimeout(() => {
					this.props.history.push({
						pathname: `/consent-status`,
						state: {
							status: 'Consent approval failed',
							statusCode: 20,
						},
					});
				}, 1000);
			}
		} catch (error) {
			console.error('Error approving consent:', error);
			toast.error('An error occurred while approving consent');
			this.setState({ isDisable: false });
			setTimeout(() => {
				this.props.history.push({
					pathname: `/consent-status`,
					state: {
						status: 'Consent approval failed',
						statusCode: 20,
					},
				});
			}, 1000);
		}
	};

	getUserdetails = async () => {
		const res = await this.authApis.getUserInfo();
		if (res?.status && res?.status === 'ACCEPT') {
			console.log(res, 'this.getUserdetails');
			global.mobileNumber = res.UserInfo.mobileNo;
			global.userId = res.UserInfo.userId;
			global.pan = res?.UserInfo?.panProvided;
			global.dob = res?.UserInfo?.dobProvided;
			global.mobileNumberArray.push(res.UserInfo.mobileNo);
			this.setState({ mobileNo: res.UserInfo.mobileNo });
			toast.success(`${this.props.t('login.messages.welcomeMessage')} ${global.userId}`);
			return res;
			// return new Promise( res);
		} else {
			if (res?.code === undefined || res?.code === null || res?.code === "") {
				toast.error(res?.message);
			} else {
				toast.error(this.props.t(`errors.code.${res.code}`));
			}
			this.setState({ isDisable: false });
			if (res.status === 'FAILURE') {
				postMessage('session', 'FAILURE');
			} else if (res.status === 'ERROR') {
				postMessage('session', 'ERROR');
			}
		}
	};
	/*otp toggle*/
	getOtp = () => {
		this.setState({ isResend: false, OTP: '' });
		this.id = setInterval(this.initiate, 1000);
	};
	checkOtpValid = () => {
		if (this.state.OTP?.length === 6 || this.state.OTP?.length === 8) {
			return false;
		}
		return true;
	};
	allFips = () => {
		this.authApis.allFipsList().then(async (res) => {
			this.setState({ isDisable: true });
			if (res?.status === 'SUCCESS') {
				global.enabledFips = res?.fipsAll?.filter(
					(fip) => fip.enabled === true
				);
				let objectFormatFip = {};
				for (let i = 0; i < global?.enabledFips.length; i++) {
					objectFormatFip[global.enabledFips[i].fipId] = global.enabledFips[i];
				}
				global.objectFormatFip = objectFormatFip;
				await this.consentRequestDetails();
			} else {
				if (res?.code === undefined || res?.code === null || res?.code === "") {
					toast.error(res?.message);
				} else {
					toast.error(this.props.t(`errors.code.${res.code}`));
				}
				if (res.status === 'FAILURE') {
					postMessage('session', 'FAILURE');
				} else if (res.status === 'ERROR') {
					postMessage('session', 'ERROR');
				}
			}
		});
	};

	consentRequestDetails = async () => {
		this.authApis.consentRequestDetails().then(async (res) => {
			this.props.updateLoader(false);
			if (res.status === 'SUCCESS') {
				await this.authApis.consentRequestDetailsSingle();
				const userDetailsResponse = await this.getUserdetails();
				let mobileNum = userDetailsResponse?.UserInfo?.mobileNo;
				let validConsents = res.consentRequestList.filter(
					(el) => el.status === 'SUCCESS'
				);
				if (global.institutionType === 'LSP') {
					await this.getEntityInfo(validConsents);
				} else {
					const groupedConsents = {};
					for (const consent of validConsents) {
						const consentHash = getFiTypesHash(consent?.fiTypes);
						if (Object.keys(groupedConsents).includes(consentHash)) {
							groupedConsents[consentHash].add(consent);
						} else {
							groupedConsents[consentHash] = new Set().add(consent);
						}
					}
					validConsents = window.finvuClient.rankConsents(validConsents);
					this.context.updateCommonConsentFiTypesGroup(groupedConsents);
					this.context.updateConsentList(validConsents);
				}
			this.setState({ consentList: validConsents });
			global.consentListLength = validConsents?.length;
			global.consent =
				this.state.consentList?.length > 0
					? this.state.consentList[0]
					: validConsents[0];
			
			// Check if this is a consent renewal flow
			if (global.renewConsentId) {
				this.props.history.push({
					pathname: '/consent-renew',
					state: { data: res.consentRequestList },
				});
			} else if (this.fips) {
				this.props.history.push({
					pathname: `/accounts/${mobileNum}/${this.fips}`,
					state: { data: res.consentRequestList },
				});
			} else {
				this.props.history.push({
					pathname: `/accounts/${mobileNum}`,
					state: { data: res.consentRequestList },
				});
			}
			} else {
				if (res?.code === undefined || res?.code === null || res?.code === "") {
					toast.error(res?.message);
				} else {
					toast.error(this.props.t(`errors.code.${res.code}`));
				}
				// this.props.history.push(`/error`)
				if (res.status === 'FAILURE') {
					postMessage('session', 'FAILURE');
				} else if (res.status === 'ERROR') {
					postMessage('session', 'ERROR');
				}
				setTimeout(() => {
					this.props.history.push({
						pathname: `/consent-status`,
						state: {
							statusCode: 20,
						},
					});
				}, 3000);
			}
		});
	};
	getEntityInfo = async (consentRequestList) => {
		for (let i = 0; i < consentRequestList?.length; i++) {
			await this.authApis
				.entityInfo(consentRequestList[i].FIU.id)
				.then((result) => {
					console.log('entity Details - ', result);
					if (result.status === 'SUCCESS') {
						consentRequestList[i].entityInfoDetails = result;
						if (consentRequestList.length - 1 === i) {
							let successConsents = consentRequestList.filter(
								(el) => el.status === 'SUCCESS'
							);
							global.selectedLSP = [...successConsents];
							this.setState({
								consentRequestList: [...successConsents],
								selectedAccounts: successConsents,
							});
							this.props.updateLoader(false);
							this.context.updateConsentList(successConsents);
							console.log(this.context, 'consentContext');
						}
					} else {
						this.props.updateLoader(true);
						if (result?.code === undefined || result?.code === null || result?.code === "") {
							toast.error(result?.message);
						} else {
							toast.error(this.props.t(`errors.code.${result.code}`));
						}
						if (result.status === 'FAILURE') {
							postMessage('session', 'FAILURE');
						} else if (result.status === 'ERROR') {
							postMessage('session', 'ERROR');
						}
					}
				});
		}
	};

	setTheme = (theme) => {
		this.setState({ theme });
	};

	toggleTermsModal = () => {
		const isDesktop = window.innerWidth >= 900;
		if (isDesktop) {
			this.redirectToExternalTerms();
		} else {
			this.setState((prevState) => ({
				showTermsModal: !prevState.showTermsModal,
			}));
		}
	};

	redirectToExternalTerms = () =>
		window.open('https://finvu.in/terms', '', 'width=600,height=600');

	togglePrivacyModal = () => {
		const isDesktop = window.innerWidth >= 900;
		if (isDesktop) {
			window.open('https://finvu.in/privacy', '', 'width=600,height=600');
		} else {
			this.setState((prevState) => ({
				showPrivacyModal: !prevState.showPrivacyModal,
			}));
		}
	};

	handleClick = () => {
		this.setState({ isDisable: true, disableType: 'Verify' });
	};

	handleSubmit = (event) => {
		event.preventDefault();
		this.setState({ error: '' });
	};

	openExitConfirm = () => {
		const isMobile = window.innerWidth < 900;
		this.setState(
			isMobile ? { showCancelDrawer: true } : { showCancelDialog: true }
		);
	};

	handleBack = () => {
		postMessage('exit', 'BACK');
		if (global.isRedirect) {
			if (global.redirectUrl?.includes('?')) {
				global.sendBackBtnRes
					? window.location.replace(
							global.redirectUrl +
								'&ecres=' +
								global.encryptedres +
								'&resdate=' +
								global.resDate +
								'&fi=' +
								global.encryptedFiId
					  )
					: window.location.replace(global.redirectUrl);
			} else {
				global.sendBackBtnRes
					? window.location.replace(
							global.redirectUrl +
								'?ecres=' +
								global.encryptedres +
								'&resdate=' +
								global.resDate +
								'&fi=' +
								global.encryptedFiId
					  )
					: window.location.replace(global.redirectUrl);
			}
		}
	};

	isValidMobileNumber = () => {
		const mobileNo = this?.state?.mobileNo.split('@')[0];
		return /^\d{10}$/.test(mobileNo);
	};

	handleOtpInputStart = (interactionType) => {
		if (!this.hasTrackedInputStart) {
			const currentTime = performance.now();
			const timeToFirstInteraction = currentTime - this.state.pageLoadTime;

			const inputStartMetrics = {
				timeToFirstInteraction,
				interactionType,
			};
			
			if (global.renewConsentId && this.isConsentRenewal === 'true') {
				captureConsentRenewalOtpInputStart(inputStartMetrics);
			} else {
				captureOtpInputStart(inputStartMetrics);
			}

			this.hasTrackedInputStart = true;
		}
	};

	handleOtpPaste = (e) => {
		this.handleOtpInputStart('paste');
	};

	handleOtpKeyPress = (e) => {
		if (!this.hasTrackedInputStart) {
			this.handleOtpInputStart('keypress');
		}
	};

	handleOtpChange = (otp) => {
		const newValue = otp;
		const oldLength = this.state.OTP.length;
		const newLength = newValue.length;

		// Track corrections (backspace/delete)
		if (newLength < oldLength) {
			this.setState((prevState) => ({
				correctionCount: prevState.correctionCount + 1,
			}));
		}

		// Track progress if we've reached a milestone
		if (newLength > oldLength && shouldTrackOtpProgress(newLength)) {
			const metrics = calculateOtpProgressMetrics(
				newLength,
				this.state.lastInputTime,
				this.state.pageLoadTime,
				this.state.correctionCount
			);
			
			if (global.renewConsentId && this.isConsentRenewal === 'true') {
				captureConsentRenewalOtpInputProgress(metrics);
			} else {
				captureOtpInputProgress(metrics);
			}
		}

		this.setState({
			OTP: newValue,
			lastInputTime: performance.now(),
			errors: { otp: false, message: '' },
		});
	};
	render() {
		if (!this.props.sdkReady) {
			return (
				<Box sx={{ display: 'flex' }}>
					<CircularProgress />
			 	</Box>
			);
		}
		const { t } = this.props;
		const dynamicOtpPageHeading = getOtpPageHeading([global.entityName, this.state.name, this.state.mobileNo.split('@')[0]], t);
		const dynamicOtpPageSubHeading = getOtpPageSubHeading(this.reviewConsentParams, this.state.consentDetailList, t);

		// Check for dark theme
		const isDark = this.props.customDetails?.darkTheme === true || this.state.theme?.palette?.mode === 'dark';

		const isContinuingAfterMfa = Boolean(
			is2FAEnabled(this.props.customDetails) &&
			(this.props.location?.state?.continueAfterMfa || this._resumeAfterMfaStarted)
		);
		if (isContinuingAfterMfa) {
			return (
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						height: '100vh',
						width: '100vw',
						backgroundColor: isDark ? '#121212' : '#FFFFFF',
					}}
				>
					<CircularProgress
						size={48}
						sx={{ color: this.props.customDetails?.primaryColor || '#3053D3' }}
					/>
				</Box>
			);
		}

		const isMobile = window.innerWidth < 1200;
		const showTrustMarker =
			!this.state.reviewConsentFlow &&
			this.props.customDetails?.disableTrustMarkers !== 'true';

		return this.state.isExpired ? (
			<Expired />
		) : (
			<StepperContext.Consumer>
				{({ nextStep }) => (
				<>
					<Box sx={{
						height: '100vh',
						display: 'flex',
						flexDirection: 'column',
						overflow: 'hidden',
					}}>
					{showTrustMarker && (
						<Box sx={{
							width: '100%',
							flexShrink: 0,
							marginTop: `${this.state.headerHeight}px`,
							'& > div': {
								padding: '12px 20px !important',
							},
						}}>
							<TrustMarker customDetails={this.props.customDetails} noBorderRadius={true} />
						</Box>
					)}
					<Box sx={{
						...loginLeftStyles.container,
						flex: 1,
						minHeight: 0,
						// backgroundColor: isDark ? '#161616' : '#fff',
						color: isDark ? '#fff' : '#000',
						paddingTop: showTrustMarker ? 0 : `${this.state.headerHeight}px`,
						paddingBottom: global.renewConsentId ? '50px' : '0',
							overflow: 'hidden',
							...(this.props?.customDetails?.loginCoverImage && {
								backgroundImage:`url(${this.props?.customDetails?.loginCoverImage})`,
								backgroundPosition:"center",
								backgroundSize:"cover"
							})
						}}>
							<SetTheme
								customDetails={this.props.customDetails}
								setTheme={this.setTheme}
							/>
					<Box sx={{
						...this.state.reviewConsentFlow ? loginStyles.containerWithoutStepper : loginStyles.container,
						backgroundColor: isDark ? '#161616' : '#fff',
						color: isDark ? '#fff' : '#000',
						background:"transparent",
						overflow: 'hidden',
						flex: 1,
						minHeight: 0,
						...(showTrustMarker ? {
							padding: {
								xs: '3rem 1.5rem 1rem 1.5rem',
								sm: '3rem 1.5rem 1rem 1.5rem',
								md: '3rem 1.5rem 1rem 1.5rem',
								lg: '3rem 4rem 1rem 4rem',
								xl: '3rem 5.5rem 1rem 5.5rem',
							},
						} : global.renewConsentId ? {
							padding: {
								xs: '5rem 1.5rem 4rem 1.5rem',
								sm: '5rem 1.5rem 4rem 1.5rem',
								md: '5rem 1.5rem 4rem 1.5rem',
								lg: '5rem 4rem 5rem 4rem',
								xl: '5rem 5.5rem 6.2rem 5.5rem',
							},
						} : {}),
					}}>
	{this.state.reviewConsentFlow ? null : (
	<StepperBar
		login={true}
		customDetails={this.props.customDetails}
		onInfoClick={() => isMobile
			? this.setState({ showInfoDrawer: true })
			: this.setState({ showInfoDialog: true })
		}
	/>
	)}
				<Stack
					spacing={'1rem'}
					justifyContent={{ xs: 'space-between', md: 'space-between' }}
					sx={{ flex: 1, minHeight: 0, overflow: 'hidden' }}
				>
								<Stack sx={loginStyles.otpContainer}>
								<Box width={'100%'} textAlign={'start'}>
									{/* Heading — config: customDetails.disableHeading */}
									{this.props.customDetails?.disableHeading !== "true" && (
										<Typography
											id={PAGE_HEADING_ID}
											component="h1"
											sx={{
												...loginStyles.headingText,
												fontFamily: this.props?.customDetails?.fontFamily,
												color: this.props.customDetails?.primaryTextColor ?? (isDark ? '#fff' : '#000'),
											}}
										>
											{dynamicOtpPageHeading}
										</Typography>
									)}
								<Box sx={loginStyles.heading}>
										{/* Subheading — config: sdkOptions.noWelcomeText hides for both new+old */}
										{global.noWelcomeText !== true && global.noWelcomeText !== 'true' && (
										this.state.loginStage === 'VERIFY_OTP'
										? <Typography
											maxWidth={'90%'}
											variant="h6"
											sx={{
												...loginStyles.subHeading,
												fontFamily: this.props.customDetails.fontFamily,
												color: this.props.customDetails?.secondaryTextColor ?? (isDark ? '#7A8185' : '#6C6C6C'),
											}}
										>
											{this.state.newUser === 'N'
												? `Welcome back, please enter the OTP sent to the number linked to your handle, ${this.state.mobileNo}.`
												: `Please enter the OTP sent to the number linked to your handle, ${this.state.mobileNo}.`
											}
										</Typography>
										: <Typography
											maxWidth={'90%'}
											variant="h6"
											sx={{
												...loginStyles.subHeading,
												fontFamily: this.props.customDetails.fontFamily,
												color: this.props.customDetails?.secondaryTextColor ?? (isDark ? '#7A8185' : '#6C6C6C'),
											}}
										>
											{dynamicOtpPageSubHeading}
										</Typography>
										)}
										{!this.state.reviewConsentFlow && !isMobile && <Link
											textAlign={this.props.customDetails?.disableTrustMarkers || global.disableSubHeading ? 'start' : 'end'}
											variant="button"
											underline="none"
											flex={1}
											color={this.props.customDetails.primaryColor}
											onClick={() => this.setState({ showDetails: true })}
											sx={{
												...loginLeftStyles.help,
												fontFamily: this.props?.customDetails?.fontFamily,
												color: this.props.customDetails?.primaryTextColor ?? (isDark ? '#fff' : '#000'),
											}}
										>
											{t('common.buttons.info')}
										</Link>
										}
										</Box>
								</Box>
								<Box sx={loginStyles.inputContainer}>
										{
											this.state.loginStage === "VERIFY_OTP" ? <>
											<LoginOtpGroupedField
												value={this.state.OTP} // controlled OTP state
												onChange={(otp) => this.handleOtpChange(otp)} 
												length={6} // 6 separate boxes
												error={this.state.errors?.otp === true}
												helperText={
													this.state.errors?.otp === true
														? this.state.errors?.message ||
															t('login.messages.otpVerificationFailed')
														: null
												}
												primaryColor={this.props?.customDetails.primaryColor}
												fontFamily={this.props?.customDetails.fontFamily}
												onOtpInputStart={this.handleOtpInputStart}
  												onOtpPaste={this.handleOtpPaste}
  												handleOtpKeyPress={this.handleOtpKeyPress}
												labelId={PAGE_HEADING_ID}
												customDetails={this.props?.customDetails}
											/>
										<Typography
											fontSize={'0.875rem'}
											fontFamily={this.props.customDetails?.fontFamily}
											sx={{
												color: this.props.customDetails?.secondaryTextColor ?? (isDark ? '#7A8185' : '#888'),
											}}
										>
											Didn&apos;t receive OTP?&nbsp;
											{this.state.time !== 60 ? (
												<>Try Again in {this.state.time} {t('common.messages.seconds')}</>
											) : (
												<Link
													component="button"
													underline="none"
													fontWeight={600}
													sx={{
														fontSize: '0.875rem',
														fontFamily: this.props.customDetails?.fontFamily,
														color: this.props.customDetails?.primaryColor,
														cursor: 'pointer',
														verticalAlign: 'baseline',
													}}
													onClick={() => this.sendOtp(false, nextStep)}
												>
													Try Again
												</Link>
											)}
										</Typography>
										</> : 
										this.state.loginStage === "PRE_AUTH_CHECK" ? 
										<Box>
											{this.state.isSNAConfigured && (
												<Box sx={{ mb: 2, textAlign: 'start' }}>
													<Typography
														fontSize={'0.875rem'}
														fontFamily={this.props.customDetails?.fontFamily}
														color={this.props.customDetails?.textColor}
														sx={{ mb: 1 }}
													>
														Confirm your mobile number so we can verify it securely with your SIM provider.
														<Link
														variant="button"
														// underline="none"
														color={this.props.customDetails?.primaryColor}
														onClick={() => this.setState({ showSNADrawer: true })}
														sx={{
															marginLeft:"4px",
															cursor: 'pointer',
															textTransform: 'capitalize',
															fontSize: '0.875rem',
															fontFamily: this.props.customDetails?.fontFamily,
														}}
													>
														Know more
													</Link>
													</Typography>
													
												</Box>
											)}
												<Box
													padding={'1rem'}
													sx={{
														...loginStyles.otpText,
														color: this.props.customDetails.textColor,
														backgroundColor:
															this.props.customDetails?.secondaryColor,
													}}
												>
													<Typography>{`${global.mobileNumber ?? "Registered Mobile Number"}`}</Typography>
												</Box>
										</Box>
										: <></>
										}
										
									</Box>
							</Stack>
						{/* Bottom group — space-between pushes this to bottom of the outer Stack */}
						<Box sx={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
						{/* "Secure & Quick" badge directly above Continue */}
						{!this.state.reviewConsentFlow && this.props.customDetails?.disableTrustMarkers !== "true" && (
							<LoginFooter mode="secure" />
						)}
						<Divider sx={{ mx: '-1.5rem', width: 'calc(100% + 3rem)' }} />
					<Button
						variant="contained"
						size="large"
						sx={{
							backgroundColor: this.props.customDetails?.ctaBackgroundColor ?? this.props?.customDetails?.primaryColor,
									textTransform: 'capitalize',
									fontSize: '0.875rem',
									border: `1px solid ${this.props?.customDetails?.ctaBorderColor ?? this.props?.customDetails?.primaryColor}`,
										'&:focus': {
											backgroundColor: this.props.customDetails?.ctaBackgroundColor ?? this.props?.customDetails?.primaryColor,
										},
										'&:hover': {
											backgroundColor: this.props.customDetails?.ctaHoverPrimaryColor ?? this.props?.customDetails?.primaryColor,
											border: this.props.customDetails?.ctaHoverBorderColor ? `1px solid ${this.props.customDetails?.ctaHoverBorderColor}` : `1px solid ${this.props.customDetails?.primaryColor}`,
										},
										'&.Mui-disabled': {
											backgroundColor: isDark ? '#7A8185' : '#E0E0E0',
											color: isDark ? '#161616' : '#9E9E9E',
											border: isDark ? '1px solid #7A8185' : '1px solid #E0E0E0',
										},
										borderRadius: this.props.customDetails?.borderRadius,
										boxShadow: 'none',
										color: this.props.customDetails?.ctaTextColor ?? (isDark ? '#161616' : '#fff'),
									}}
								disabled={
									this.state.loginStage === 'PRE_AUTH_CHECK'
										? !this.state.mobileNo || this.state.mobileNo.trim().length === 0
										: this.state.loginStage === 'VERIFY_OTP'
											? this.state.OTP?.length !== 6 && this.state.OTP?.length !== 8
											: false
								}
								endIcon={<ArrowForwardIcon />}
								onClick={(e) => {
									if(this.state.loginStage === 'PRE_AUTH_CHECK'){
										this.sendOtp(false, nextStep);
										this.props.updateLoginStageLoader({isLoading: true, loadingText: ""});
									}
									else if(this.state.loginStage == 'VERIFY_OTP'){
										this.verifyOtp(e, nextStep)
									}
									
								}}
							>
							{t('common.buttons.continue')}
						</Button>
				<Typography sx={{
					fontSize: '0.75rem',
					fontWeight: 400,
					textAlign: 'center',
					color: this.props.customDetails?.secondaryTextColor ?? (isDark ? '#7A8185' : '#888'),
					fontFamily: this.props.customDetails?.fontFamily,
				}}>
						{t('common.messages.byContinuing')}<br />
						Finvu&apos;s&nbsp;<Link
							component={'button'}
							underline="none"
							fontWeight={700}
							sx={{
								color: this.props.customDetails?.primaryTextColor ?? (isDark ? '#fff' : this.props.customDetails?.primaryColor),
								fontFamily: this.props.customDetails?.fontFamily,
								fontSize: '0.75rem',
								verticalAlign: 'baseline',
							}}
							onClick={this.toggleTermsModal}
						>{t('login.titles.termsAndConditions')}</Link>&nbsp;&amp;&nbsp;						<Link
							component={'button'}
							underline="none"
							fontWeight={700}
							sx={{
								color: this.props.customDetails?.primaryTextColor ?? (isDark ? '#fff' : this.props.customDetails?.primaryColor),
								fontFamily: this.props.customDetails?.fontFamily,
								fontSize: '0.75rem',
								verticalAlign: 'baseline',
							}}
							onClick={this.togglePrivacyModal}
						>Privacy Policy</Link>
					</Typography>

								<Dialog
									open={this.state.showTermsModal}
									onClose={this.toggleTermsModal}
									fullWidth
									maxWidth="md"
									disableEnforceFocus
									sx={{
										'& .MuiDialog-paper': {
											overflow: 'hidden',
											touchAction: 'auto',
											padding: '0px',
											backgroundColor: isDark ? '#161616' : '#fff',
											color: isDark ? '#fff' : '#000',
										},
									}}
								>
									<DialogContent
										sx={{
											height: { xs: '80vh', sm: '500px' },
											overflow: 'hidden',
											position: 'relative',
											padding: '0px',
											backgroundColor: isDark ? '#161616' : '#fff',
											color: isDark ? '#fff' : '#000',
										}}
									>
										<IconButton
											aria-label={t('common.buttons.close')}
											onClick={this.toggleTermsModal}
											sx={{ 
												position: 'absolute', 
												right: 8, 
												top: 8, 
												zIndex: 2,
												color: isDark ? '#fff' : '#000',
											}}
										>
											<CloseIcon />
										</IconButton>
										<div
											style={{
												width: '100%',
												height: '100%',
												overflow: 'hidden',
												position: 'relative',
												padding: '0px',
											}}
										>
											<iframe
												src="https://finvu.in/terms"
												title="Terms and Conditions"
												width="100%"
												height="100%"
												style={{
													border: 'none',
													position: 'absolute',
													top: 0,
													left: 0,
													width: '100%',
													height: '100%',
												}}
											/>
										</div>
									</DialogContent>
					</Dialog>

					<Dialog
						open={this.state.showPrivacyModal}
						onClose={this.togglePrivacyModal}
						fullWidth
						maxWidth="md"
						disableEnforceFocus
						sx={{
							'& .MuiDialog-paper': {
								overflow: 'hidden',
								touchAction: 'auto',
								padding: '0px',
								backgroundColor: isDark ? '#161616' : '#fff',
								color: isDark ? '#fff' : '#000',
							},
						}}
					>
						<DialogContent
							sx={{
								height: { xs: '80vh', sm: '500px' },
								overflow: 'hidden',
								position: 'relative',
								padding: '0px',
								backgroundColor: isDark ? '#161616' : '#fff',
								color: isDark ? '#fff' : '#000',
							}}
						>
							<IconButton
								aria-label={t('common.buttons.close')}
								onClick={this.togglePrivacyModal}
								sx={{
									position: 'absolute',
									right: 8,
									top: 8,
									zIndex: 2,
									color: isDark ? '#fff' : '#000',
								}}
							>
								<CloseIcon />
							</IconButton>
							<div style={{ width: '100%', height: '100%', overflow: 'hidden', position: 'relative', padding: '0px' }}>
								<iframe
									src="https://finvu.in/privacy"
									title="Privacy Policy"
									width="100%"
									height="100%"
									style={{ border: 'none', position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
								/>
							</div>
						</DialogContent>
					</Dialog>
					</Box>{/* end bottom group */}
			</Stack>
						</Box>
						{this.state.reviewConsentFlow ? null : <LoginRight
							theme={this.state.theme}
							customDetails={this.props.customDetails}
						/>}
				<DialogBox
					open={this.state.showDetails}
					handleClose={() => this.setState({ showDetails: false })}
					boxPadding="1.25rem"
					marginTopChildren={'0.75rem'}
					subTitleMaxWidth="75%"
				>
					<LoginRightContent {...this.props} theme={this.state.theme} />
				</DialogBox>

				<DialogBox
					open={this.state.showInfoDialog}
					handleClose={() => this.setState({ showInfoDialog: false })}
					boxPadding="1.5rem"
					customDetails={this.props.customDetails}
				>
					<Typography sx={{
						fontWeight: 700,
						fontSize: '1rem',
						lineHeight: 1.4,
						mb: '1.25rem',
						fontFamily: this.props.customDetails?.fontFamily,
						color: isDark ? '#fff' : '#000',
					}}>
						Sharing data securely to lenders through Account Aggregator in 3 easy steps
					</Typography>
					{[
						{
							icon: <VpnKeyOutlinedIcon sx={{ fontSize: '1.5rem', color: isDark ? '#aaa' : '#444' }} />,
							title: 'Register',
							desc: 'Sign up onto Finvu AA, an RBI Licensed Account Aggregator using your mobile number or handle.',
						},
						{
							icon: <LinkOutlinedIcon sx={{ fontSize: '1.5rem', color: isDark ? '#aaa' : '#444' }} />,
							title: 'Select Accounts',
							desc: 'Add & choose which bank accounts you want to share. You stay in control, only selected accounts are shared.',
						},
						{
							icon: <GppGoodOutlinedIcon sx={{ fontSize: '1.5rem', color: isDark ? '#aaa' : '#444' }} />,
							title: 'Approve Consents',
							desc: 'Review the details shared and for how long. Approve to share your data securely.',
						},
					].map((step, i) => (
						<Box key={i} sx={{ mb: '1.25rem' }}>
							<Box sx={{ mb: '0.375rem' }}>{step.icon}</Box>
							<Typography sx={{
								fontWeight: 700,
								fontSize: '0.9375rem',
								fontFamily: this.props.customDetails?.fontFamily,
								color: isDark ? '#fff' : '#000',
								mb: '0.25rem',
							}}>
								{step.title}
							</Typography>
							<Typography sx={{
								fontSize: '0.875rem',
								fontFamily: this.props.customDetails?.fontFamily,
								color: isDark ? '#aaa' : '#555',
								lineHeight: 1.5,
							}}>
								{step.desc}
							</Typography>
						</Box>
					))}
					<Divider sx={{ mt: '1.5rem', mb: '1.5rem', mx: '-1.5rem', width: 'calc(100% + 3rem)' }} />
					<Button
						variant="contained"
						fullWidth
						onClick={() => this.setState({ showInfoDialog: false })}
						sx={{
							padding: '10px 0',
							borderRadius: '6px',
							backgroundColor: this.props.customDetails?.primaryColor,
							color: this.props.customDetails?.ctaTextColor ?? '#fff',
							textTransform: 'capitalize',
							fontFamily: this.props.customDetails?.fontFamily,
							boxShadow: 'none',
							'&:hover': { backgroundColor: this.props.customDetails?.primaryColor, opacity: 0.9, boxShadow: 'none' },
						}}
					>
						Understood
					</Button>
				</DialogBox>

			<DialogBox
				open={this.state.showCancelDialog}
				handleClose={() => this.setState({ showCancelDialog: false })}
				title={
					global.renewConsentId
						? t('consentRenewal.titles.cancelRenewal')
						: t('header.dialog.cancelConsent.title')
				}
				subTitle={
					global.renewConsentId
						? t('consentRenewal.messages.cancelConfirmation').replace('{fiuName}', global.entityName || 'the FIU')
						: t('header.dialog.cancelConsent.subtitle')
				}
				boxPadding="1.5rem"
				subTitleMaxWidth="85%"
				customDetails={this.props.customDetails}
				isConsentRenewal={!!global.renewConsentId}
			>
				{global.renewConsentId ? (
					<DenyConsent
						handleCancel={() => this.setState({ showCancelDialog: false })}
						handleDeny={this.handleBack}
						isDarkTheme={isDark}
						customDetails={this.props.customDetails}
						denyButtonText={t('common.buttons.yesExitJourney')}
						cancelButtonText={t('common.buttons.noGoBack')}
						isConsentRenewal={true}
					/>
				) : (
					<CancelConsent
						handleCancel={() => this.setState({ showCancelDialog: false })}
						handleDeny={this.handleBack}
						customDetails={this.props.customDetails}
					/>
				)}
				</DialogBox>

				<Drawer
					open={this.state.showCancelDrawer}
					setOpen={(open) => this.setState({ showCancelDrawer: open })}
					anchor="bottom"
					height="auto"
					customDetails={this.props.customDetails}
					showCloseBtn={false}
				>
					<Box sx={{ 
						padding: '1.5rem 1.5rem 1.5rem 1.5rem',
						fontFamily: this.props.customDetails?.fontFamily,
						backgroundColor: isDark
							? '#161616'
							: this.props.customDetails?.secondaryColor || '#fff',
					}}>
						<Typography
							sx={{
								fontSize: '1rem',
								fontWeight: 600,
								fontFamily: this.props.customDetails?.fontFamily,
								color: isDark ? '#fff' : '#000',
								marginBottom: '0.5rem',
							}}
						>
							{global.renewConsentId
								? t('consentRenewal.titles.cancelRenewal')
								: t('header.dialog.cancelConsent.title')}
						</Typography>
						<Typography
							sx={{
								fontSize: '0.875rem',
								fontFamily: this.props.customDetails?.fontFamily,
								color: isDark ? '#B0B0B0' : '#666',
								marginBottom: '2rem',
							}}
						>
							{global.renewConsentId
								? t('consentRenewal.messages.cancelConfirmation').replace('{fiuName}', global.entityName || 'the FIU')
								: t('header.dialog.cancelConsent.subtitle')}
						</Typography>
						{global.renewConsentId ? (
							<DenyConsent
								handleCancel={() => this.setState({ showCancelDrawer: false })}
								handleDeny={this.handleBack}
								isDarkTheme={isDark}
								customDetails={this.props.customDetails}
								denyButtonText={t('common.buttons.yesExitJourney')}
								cancelButtonText={t('common.buttons.noGoBack')}
								isConsentRenewal={true}
							/>
						) : (
							<CancelConsent
								handleCancel={() => this.setState({ showCancelDrawer: false })}
								handleDeny={this.handleBack}
								customDetails={this.props.customDetails}
							/>
						)}
					</Box>
					<Box sx={{ marginBottom: '-1rem' }}>
						<Footer {...this.props} />
					</Box>
				</Drawer>

				<Drawer
					open={this.state.showInfoDrawer}
					setOpen={(open) => this.setState({ showInfoDrawer: open })}
					anchor="bottom"
					height="auto"
					customDetails={this.props.customDetails}
					showCloseBtn={false}
				>
					<Box sx={{
						backgroundColor: isDark ? '#161616' : (this.props.customDetails?.secondaryColor || '#fff'),
						fontFamily: this.props.customDetails?.fontFamily,
						px: '1.5rem',
						pt: '1.5rem',
						pb: '1.5rem',
					}}>
					{/* scrollable steps only */}
					<Box sx={{ maxHeight: '55vh', overflowY: 'auto' }}>
						<Typography sx={{
							fontWeight: 700,
							fontSize: '1rem',
							lineHeight: 1.4,
							mb: '1.25rem',
							fontFamily: this.props.customDetails?.fontFamily,
							color: isDark ? '#fff' : '#000',
						}}>
							Sharing data securely to lenders through Account Aggregator in 3 easy steps
						</Typography>

						{[
							{
								icon: <VpnKeyOutlinedIcon sx={{ fontSize: '1.5rem', color: isDark ? '#aaa' : '#444' }} />,
								title: 'Register',
								desc: 'Sign up onto Finvu AA, an RBI Licensed Account Aggregator using your mobile number or handle.',
							},
							{
								icon: <LinkOutlinedIcon sx={{ fontSize: '1.5rem', color: isDark ? '#aaa' : '#444' }} />,
								title: 'Select Accounts',
								desc: 'Add & choose which bank accounts you want to share. You stay in control, only selected accounts are shared.',
							},
							{
								icon: <GppGoodOutlinedIcon sx={{ fontSize: '1.5rem', color: isDark ? '#aaa' : '#444' }} />,
								title: 'Approve Consents',
								desc: 'Review the details shared and for how long. Approve to share your data securely.',
							},
						].map((step, i) => (
							<Box key={i} sx={{ mb: '1.25rem' }}>
								<Box sx={{ mb: '0.375rem' }}>{step.icon}</Box>
								<Typography sx={{
									fontWeight: 700,
									fontSize: '0.9375rem',
									fontFamily: this.props.customDetails?.fontFamily,
									color: isDark ? '#fff' : '#000',
									mb: '0.25rem',
								}}>
									{step.title}
								</Typography>
								<Typography sx={{
									fontSize: '0.875rem',
									fontFamily: this.props.customDetails?.fontFamily,
									color: isDark ? '#aaa' : '#555',
									lineHeight: 1.5,
								}}>
									{step.desc}
								</Typography>
							</Box>
						))}
					</Box>

					{/* Divider + button outside scroll — spans full width like DenyConsent */}
					<Divider sx={{ mt: '2.5rem', mb: '1.5rem', marginLeft: '-1.5rem', marginRight: '-1.5rem', width: 'calc(100% + 3rem)' }} />
					<Button
						variant="contained"
						fullWidth
						size="large"
						onClick={() => this.setState({ showInfoDrawer: false })}
						sx={{
							borderRadius: '6px',
							backgroundColor: this.props.customDetails?.primaryColor,
							color: this.props.customDetails?.ctaTextColor ?? '#fff',
							textTransform: 'capitalize',
							fontFamily: this.props.customDetails?.fontFamily,
							boxShadow: 'none',
							'&:hover': {
								backgroundColor: this.props.customDetails?.primaryColor,
								opacity: 0.9,
								boxShadow: 'none',
							},
						}}
					>
						Understood
					</Button>
				</Box>
				<Box sx={{ marginBottom: '-1rem' }}>
					<Footer {...this.props} />
				</Box>
				</Drawer>

					<Drawer
							open={this.state.showSNADrawer}
							setOpen={(open) => this.setState({ showSNADrawer: open })}
							anchor="bottom"
							height="40vh"
							customDetails={this.props.customDetails}
						>
						<Box sx={{ p: 3, textAlign: 'start' }}>
							<Box sx={{ display: "flex", justifyContent: "start", margin: "6px 0" }}>
								<img
									src={"https://cdn.finvu.in/finvulogos/sim_card.png"}
									alt="logo"
									style={{ width: "50px", height: "50px" }}
								/>
							</Box>
							<Typography
								variant="h6"
								sx={{
									fontFamily: this.props.customDetails?.fontFamily,
									color: this.props.customDetails?.textColor,
									fontWeight: 700,
									mb: 1.5
								}}
							>
								Network provider based verification
							</Typography>
							<Typography
								sx={{
									fontFamily: this.props.customDetails?.fontFamily,
									color: this.props.customDetails?.textColor,
									lineHeight: 1.6,
									mb: 2
								}}
							>
								We securely verify your mobile number through your network provider when mobile data is enabled. No SMS is needed.
							</Typography>
							<Typography
								sx={{
									fontFamily: this.props.customDetails?.fontFamily,
									color: this.props.customDetails?.textColor,
									lineHeight: 1.6,
									mb: 2
								}}
							>
								This gives you a faster &amp; more secure way to verify your mobile number.
							</Typography>
							<Box
								sx={{
									backgroundColor: "#f5f5f5",
									borderRadius: "8px",
									p: 2,
									mb: 2
								}}
							>
								<Typography
									sx={{
										fontFamily: this.props.customDetails?.fontFamily,
										color: this.props.customDetails?.textColor,
										fontSize: "11px",
										fontWeight: 700,
										letterSpacing: "0.08em",
										mb: 1.5
									}}
								>
									SUPPORTED BY MAJOR NETWORK PROVIDERS
								</Typography>
								<Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 1 }}>
									<img
										src={"https://cdn.finvu.in/finvulogos/jio.svg"}
										alt="Jio"
										style={{ width: "20px", height: "20px" }}
									/>
									<img
										src={"https://cdn.finvu.in/finvulogos/airtel-logo-icon.svg"}
										alt="Airtel"
										style={{ width: "20px", height: "20px" }}
									/>
									<img
										src={"https://cdn.finvu.in/finvulogos/VI.svg"}
										alt="VI"
										style={{ width: "20px", height: "20px" }}
									/>
								</Box>
							</Box>
							<Typography
								sx={{
									fontFamily: this.props.customDetails?.fontFamily,
									color: this.props.customDetails?.textColor,
									fontSize: "13px",
									lineHeight: 1.6,
									mb: 1
								}}
							>
								Note: If we're unable to verify your mobile number, you'll be asked to complete verification using an OTP.
							</Typography>
							<Button
								variant="contained"
								size="large"
								onClick={() => this.setState({ showSNADrawer: false })}
								sx={{
									mt: 2,
									padding: "12px 0",
									width: "100%",
									borderRadius: "8px",
									backgroundColor: this.props.customDetails?.primaryColor,
									textTransform: 'none',
									fontFamily: this.props.customDetails?.fontFamily,
									fontSize: "16px",
									fontWeight: 600,
									'&:hover': {
										backgroundColor: this.props.customDetails?.primaryColor,
										opacity: 0.9
									}
								}}
							>
								Understood
							</Button>
						</Box>
						</Drawer>
						</Box>
					<Footer customDetails={this.props.customDetails} />
				</Box>

				{/* SNA 3-stage bottom sheet loader (MFA flow only) */}
				{is2FAEnabled(this.props.customDetails) && (
					<SnaLoader
						open={this.state.snaLoader}
						outcome={this.state.snaOutcome}
						primaryColor={this.props.customDetails?.primaryColor}
						customDetails={this.props.customDetails}
						onDone={() => {
							console.log('[Login.js] SnaLoader onDone — hiding sheet');
							this.setState({ snaLoader: false, snaOutcome: null });
						}}
						onFail={() => {
							console.log('[Login.js] SnaLoader onFail — hiding sheet, falling back to OTP');
							this.setState({ snaLoader: false, snaOutcome: null });
							this.otpFlowHandler({ status: 'SEND' });
						}}
					/>
				)}
				</>
				)}
			</StepperContext.Consumer>
		);
	}
}

export default withTranslation(Login);
